import React from 'react'
import cls from './switch.module.scss'
import classNames from 'classnames'

/**
 * @param {Object} props
 * @param {boolean} props.checked
 * @param {boolean} [props.disabled]
 * @param {import('react').ChangeEventHandler<HTMLInputElement>} [props.onChange]
 * @param {string} [props.checkedColor] - The color to apply when the switch is checked.
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style]
 * @returns {JSX.Element}
 */
export const Switch = ({ checked, onChange, disabled, checkedColor, className, style }) => {
  const styleSpan = {
    backgroundColor: checkedColor,
  }

  return (
    <label className={classNames(cls.switch, className)} style={style}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      <span className={cls.slider} style={checkedColor && checked ? styleSpan : null}></span>
    </label>
  )
}
